var _circle, _path, _path2;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgAssignationStatus(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 15,
    cy: 15,
    r: 15,
    fill: "#E2E8EE"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15 16C17.7614 16 20 13.7614 20 11C20 8.23858 17.7614 6 15 6C12.2386 6 10 8.23858 10 11C10 13.7614 12.2386 16 15 16Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M15 18C13.3389 18.0063 11.7132 18.4827 10.3096 19.3747C8.90601 20.2667 7.78136 21.5381 7.06477 23.0428C7.01635 23.1449 6.99447 23.2577 7.00118 23.3705C7.00789 23.4834 7.04297 23.5927 7.10315 23.6883C7.16332 23.7839 7.24663 23.8626 7.3453 23.9171C7.44396 23.9716 7.55477 24.0001 7.66738 24H22.3326C22.4452 24.0001 22.556 23.9716 22.6547 23.9171C22.7534 23.8626 22.8367 23.7839 22.8969 23.6883C22.957 23.5927 22.9921 23.4834 22.9988 23.3705C23.0055 23.2577 22.9836 23.1449 22.9352 23.0428C22.2186 21.5381 21.094 20.2667 19.6904 19.3747C18.2868 18.4827 16.6611 18.0063 15 18Z",
    fill: "white"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAssignationStatus);
export default __webpack_public_path__ + "static/media/assignation-status.da4018b1bb78b9e23f4774763c64cc79.svg";
export { ForwardRef as ReactComponent };